
import store from '../store';
import Constants from '../config/constants';
import {serviceCreateAppUsers, serviceGetAppUsers, serviceUpdateAppUsers,serviceDeleteAppUsers} from "../services/AppUsers.service";

export const FETCH_INIT = 'FETCH_INIT_APP_USERS';
export const FETCHED = 'FETCHED_APP_USERS';
export const FETCHED_FAIL = 'FETCHED_FAIL_APP_USERS';
export const FETCHED_FILTER = 'FETCHED_FILTER_APP_USERS';
export const FETCH_NEXT = 'FETCH_NEXT_APP_USERS';
export const FILTER = 'FILTER_APP_USERS';
export const RESET_FILTER = 'RESET_FILTER_APP_USERS';
export const SET_SORTING = 'SET_SORTING_APP_USERS';
export const SET_FILTER = 'SET_FILTER_APP_USERS';
export const SET_PAGE = 'SET_PAGE_APP_USERS';
export const CHANGE_PAGE = 'CHANGE_PAGE_APP_USERS';
export const CHANGE_STATUS= 'CHANGE_AppUsers_APP_USERS';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_APP_USERS';
export const CREATE_DATA = 'CREATE_APP_USERS';
export const UPDATE_DATA = 'UPDATE_APP_USERS';
export const DELETE_ITEM = 'DELETE_APP_USERS';
export const DRAG_ITEM = 'DRAG_APP_USERS';

export function actionFetchAppUsers(index = 1, sorting = {}, filter = {}, shouldReset=false) {
    const request = serviceGetAppUsers({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionCreateAppUsers(data) {
    const request = serviceCreateAppUsers(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                dispatch({type: CREATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionUpdateAppUsers(data) {
    const request = serviceUpdateAppUsers(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                dispatch({type: UPDATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionDeleteAppUsers(id) {
    const request = serviceDeleteAppUsers({ id: id});
    return (dispatch) => {
        dispatch({type: DELETE_ITEM, payload: id})
    }
}


export function actionChangePageAppUsersRequests(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

// export function nextPRequestsClick() {
//     return {
//         type: NEXT_PREQUESTS,
//         payload: null,
//     };
// }
//
// export function prevPRequestsClick() {
//     return {
//         type: PREV_PREQUESTS,
//         payload: null,
//     };
// }

export function actionFilterAppUsers(value) {
    const request = null;////serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});//dispatch function
        });
    };
}


export function actionChangeStatusAppUsers(id, status) {
    // const request = serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
        // request.then((data) => {
        //     dispatch({type: FILTER_PREQUESTS, payload: data});
        //     dispatch({type: FETCHED_PREQUESTS, payload: null});
        // });
    };
}

export function actionResetFilterAppUsers() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}



export function actionSetPageAppUsers(page) {
    const stateData = store.getState().appusers;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchAppUsers(serverPage + 1, sortingData, {query, query_data: queryData}));
        // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    }


    return {
        type: CHANGE_PAGE,
        payload: page,
    };
    // if (this.props.totalUsers <= ((this.props.currentPage + 1) * 100)) {
    //         // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order);
    //         this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    //     }

}
